import { FormControl } from "@material-ui/core";

export default function DenseFormControl(props) {
  return (
    <FormControl margin="dense" fullWidth variant="outlined">
      {props.children}
    </FormControl>
  )
}
